<template>
  <b-modal id="show_invoice_modal" ref="show_invoice_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1><i class="fas fa-file-invoice"></i> INVOICE</h1>
        <p id="mh-info">For {{ $store.state.client_timesheets.invoice_modal.first_name }} {{ $store.state.client_timesheets.invoice_modal.surname }}
        </p>
      </div>

      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <h2 class="bp-color">INVOICE</h2>

    <div class="row" style="margin-left: -15px; margin-right: -15px">
      <div class="col-lg-7">
        <!-- PERSONAL -->
        <div v-if="$store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_company_name === null">
          <p class="mb-2">
            <i class="fas fa-user" style="vertical-align: top; padding-top: 5px; padding-right: 5px; width: 20px; text-align: center;"></i>
            <span class="d-inline-block">{{ $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_name }}</span>
          </p>
          <p class="mb-2">
            <i class="fas fa-home" style="vertical-align: top; padding-top: 5px; padding-right: 5px; width: 20px; text-align: center;"></i>
            <span class="d-inline-block" v-html="$store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_address.replaceAll(', ', '<br>')"></span>
          </p>
        </div>
        <!-- BUSINESS -->
        <div v-else>
          <p class="mb-2">
            <i class="fas fa-user-tie" style="vertical-align: top; padding-top: 5px; padding-right: 5px; width: 20px; text-align: center;"></i>
            <span class="d-inline-block">{{ $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_company_name }}</span>
          </p>
          <p class="mb-2">
            <i class="fas fa-building" style="vertical-align: top; padding-top: 5px; padding-right: 5px; width: 20px; text-align: center;"></i>
            <span class="d-inline-block"
                  v-html="$store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_company_address.replaceAll(', ', '<br>')"></span>
          </p>
        </div>

        <p class="mb-0">
          <i class="fas fa-envelope-square" style="vertical-align: top; padding-top: 5px; padding-right: 5px; width: 20px; text-align: center;"></i>
          <span class="d-inline-block">{{ $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_email }}</span>
        </p>
        <p>
          <i class="fas fa-phone-square-alt" style="vertical-align: top; padding-top: 5px; padding-right: 5px; width: 20px; text-align: center;"></i>
          <span class="d-inline-block">{{ $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_phone }}</span>
        </p>
      </div>
      <div class="col-lg-5">
        <h5 class="d-inline-block" style="vertical-align: top; padding-right: 5px;">TO</h5>
        <div class="d-inline-block">
          <p class="mb-2">{{ $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.crm_company }}</p>
          <p v-html="$store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.crm_address.replaceAll(', ', '<br>')"></p>
        </div>
        <div class="mb-3" style="border: 1px solid #333333; padding: 5px 10px;">
          <p class="mb-0"><strong>Invoice Num :</strong> &nbsp;&nbsp; {{ $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_invoice_number }}</p>
          <p class="mb-0"><strong>Invoice Date :</strong> &nbsp;&nbsp;
            {{ $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_invoice_date | formatDate }}</p>
        </div>
      </div>
      <div class="col-12">
        <p><strong>End Client :</strong> &nbsp;&nbsp; <span
            class="d-inline-block">{{ $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.end_client_name }}</span></p>
      </div>
    </div>

    <div class="row" style="margin-left: -15px; margin-right: -15px;">
      <div class="col-12">
        <div style="overflow: scroll">
          <div class="table-responsive no-more-tables" style="overflow-x: visible">
            <table class="table table-bordered invoice_table">
              <thead>
              <tr>
                <th style="min-width: 125px">Type</th>
                <th style="min-width: 460px;">Description</th>
                <th style="min-width: 95px">Quantity</th>
                <th style="min-width: 100px">Unit</th>
                <th style="min-width: 115px">Unit Price</th>
                <th style="min-width: 115px">Total</th>
              </tr>
              </thead>
              <tbody v-for="day in $store.state.client_timesheets.invoice_modal.invoice.timesheet_pay">
              <tr class="day_row">
                <td colspan="5"><p class="text-uppercase mb-0" style="font-weight: bold">{{ invoice_day(day.pay_date) }}</p></td>
                <td><p class="text-uppercase mb-0" style="font-weight: bold">{{ day.price | currency }}</p></td>
              </tr>
              <tr class="invoice_lines">
                <td>Basic Rate</td>
                <td style="padding-top: 0; padding-bottom: 0;" v-if="$store.state.client_timesheets.invoice_modal.invoice.assignment.position_rate.pay_type === 'Price'">
                  Total Hours : {{ day.hours_total }}
                </td>
                <td v-else>
                  -
                </td>
                <td v-if="$store.state.client_timesheets.invoice_modal.invoice.assignment.position_rate.pay_type === 'Price'">1</td>
                <td v-else>
                  {{ day.hours_total }}
                </td>

                <td v-if="$store.state.client_timesheets.invoice_modal.invoice.assignment.position_rate.pay_type === 'Price'">
                  {{ $store.state.client_timesheets.invoice_modal.invoice.assignment.position_rate.pay_amount | currency }}
                </td>
                <td v-else>{{ $store.state.client_timesheets.invoice_modal.invoice.assignment.position_rate.pay_type }}</td>

                <td v-if="$store.state.client_timesheets.invoice_modal.invoice.assignment.position_rate.pay_type === 'Price'">
                  {{ day.price | currency }}
                </td>
                <td v-else>{{ $store.state.client_timesheets.invoice_modal.invoice.assignment.position_rate.pay_amount | currency }}</td>

                <td>{{ day.price | currency }}</td>
              </tr>
              <tr v-for="i_line in filter_invoice_lines($store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.timesheet_worker_invoice_details, day.id)"
                  class="invoice_lines">
                <td style="padding-top: 5px; padding-bottom: 5px;">
                </td>
                <td>
                  {{ i_line.description }}
                </td>
                <td>
                  {{ i_line.quantity }}
                </td>
                <td>
                  {{ i_line.unit }}
                </td>
                <td>
                  {{ i_line.unit_price | currency }}
                </td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-left: -15px; margin-right: -15px"
         v-if="$store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.vat_applicable || $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_company_ltd_reg_number !== null">
      <div class="col-12">
        <hr>
      </div>
      <div class="col-lg-6" v-if="$store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.vat_applicable">
        <p><strong>VAT NUMBER : </strong> {{ $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.vat_number }}</p>
      </div>
      <div class="col-lg-6" v-if="$store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_company_ltd_reg_number !== null">
        <p><strong>LTD REGISTRATION NUMBER : </strong> {{ $store.state.client_timesheets.invoice_modal.invoice.timesheet_worker_invoice.worker_company_ltd_reg_number }}</p>
      </div>
    </div>

  </b-modal>
</template>

<script>
export default {
  name: "show_invoice",
  mounted() {

  },
  methods: {
    hideModal() {
      this.$refs.show_invoice_modal.hide();
      this.$store.commit('HIDE_INVOICE_MODAL');
    },
    invoice_day(date) {
      return this.$moment.utc(date).format('dddd') + ' ' + this.$moment.utc(date).format('DD/MM/YYYY')
    },
    filter_invoice_lines(invoice_details, ts_pay_id) {
      return invoice_details.filter(i_dets => i_dets.ts_pay_id === ts_pay_id);
    },
  }
}
</script>

<style lang="scss">

#show_invoice_modal {
  .modal-dialog {
    max-width: 1100px;

  }

  .table td {
    vertical-align: middle !important;
  }

}
</style>
